export const WIDGET_LOADING_TIMEOUT = 1500;

export const KYC_AUTOMATIC = {
  KYC_ELECTRONIC_ID: "KYC_ELECTRONIC_ID",
  NIE_EU_ADDITIONAL_DATA: "NIE_EU_ADDITIONAL_DATA",
  ADDITIONAL_DATA_GROUP: "ADDITIONAL_DATA_GROUP",
};

export const CLIENT_SIDE_KYC_AUTOMATIC = {
  KYC_ELECTRONIC_ID: "KYC_ELECTRONIC_ID",
  NIE_EU_ADDITIONAL_DATA: "NIE_EU_ADDITIONAL_DATA",
};

export const KYC_AUTOMATIC_OPTINS_TYPES_LIST = [
  {
    biometric_data_consent: "biometric_data_consent",
  },
  {
    caixabank_biometric_data_consent: "caixabank_biometric_data_consent",
  },
];

export const helpingMessages = {
  "Https.Required": {
    textId: "ELECTRONIC_ID_HTTPS_REQUIRED",
    type: "error",
  },
  "Image.Blurred": {
    textId: "ELECTRONIC_ID_IMAGE_BLURRED",
    type: "error",
  },
  "Authorization.Invalid": {
    textId: "ELECTRONIC_ID_AUTHORIZATION_INVALID",
    type: "error",
  },
  "MaxLength.Exceeded": {
    textId: "ELECTRONIC_ID_MAX_LENGTH_EXCEEDED",
    type: "error",
  },
  "Document.Tampered": {
    textId: "ELECTRONIC_ID_DOCUMENT_TAMPERED",
    type: "error",
  },
  "VideoID.Error": {
    textId: "ELECTRONIC_ID_ERROR",
    type: "error",
  },
  "Luminance.TooHigh": {
    textId: "ELECTRONIC_ID_LUMINANCE_TOO_HIGH",
    type: "warning",
  },
  "Luminance.TooLow": {
    textId: "ELECTRONIC_ID_LUMINANCE_TOO_LOW",
    type: "warning",
  },
  "InactiveUser.Aborted": {
    textId: "ELECTRONIC_ID_INACTIVE_USER_ABORTED",
    type: "error",
  },
  "User.Aborted": {
    textId: "ELECTRONIC_ID_USER_ABORTED",
    type: "error",
  },
  "IdType.Invalid": {
    textId: "ELECTRONIC_ID_TYPE_INVALID",
    type: "error",
  },
  "DocumentSides.Mismatch": {
    textId: "ELECTRONIC_ID_DOCUMENT_SIDES_MISMATCH",
    type: "error",
  },
  "Microphone.NotFound": {
    textId: "ELECTRONIC_MICROPHONE_NOT_FOUND",
    type: "error",
  },
  "MaxFps.Exceeded": {
    textId: "ELECTRONIC_ID_MAX_FPS_EXCEEDED",
    type: "error",
  },
  "Camera.InvalidRequirements": {
    textId: "ELECTRONIC_ID_CAMERA_INVALID_REQUIREMENTS",
    type: "error",
  },
  "Document.Glared": {
    textId: "ELECTRONIC_ID_DOCUMENT_GLARED",
    type: "error",
  },
  "Device.NotSupported": {
    textId: "ELECTRONIC_ID_DEVICE_NOT_SUPPORTED",
    type: "error",
  },
  "Permissions.Refused": {
    textId: "ELECTRONIC_ID_PERMISSIONS_REFUSED",
    type: "error",
  },
  "FacesMismatch.Detected": {
    textId: "ELECTRONIC_ID_FACES_MISMATCH",
    type: "error",
  },
  "MultipleFaces.Detected": {
    textId: "ELECTRONIC_ID_MULTIPLE_FACES",
    type: "error",
  },
  "CameraResolution.TooLow": {
    textId: "ELECTRONIC_ID_CAMERA_RESOLUTION_TOO_LOW",
    type: "error",
  },
  "Connection.Error": {
    textId: "ELECTRONIC_ID_CONNECTION_ERROR",
    type: "error",
  },
  "Connection.Interrumpted": {
    textId: "ELECTRONIC_ID_CONNECTION_INTERRUPTED",
    type: "error",
  },
  "VideoID.Rejected": {
    textId: "ELECTRONIC_ID_VIDEO_ID_REJECTED",
    type: "error",
  },
  "Document.NotAllowed": {
    textId: "ELECTRONIC_ID_DOCUMENT_NOT_ALLOWED",
    type: "error",
  },
  "Camera.NotFound": {
    textId: "ELECTRONIC_ID_CAMERA_NOT_FOUND",
    type: "error",
  },
  "AccessToken.Invalid": {
    textId: "ELECTRONIC_ID_ACCESS_TOKEN_INVALID",
    type: "error",
  },
  "Agent.Aborted": {
    textId: "ELECTRONIC_ID_AGENT_ABORTED",
    type: "error",
  },
  "VideoID.NotSupported": {
    textId: "ELECTRONIC_ID_VIDEO_ID_NOT_SUPPORTED",
    type: "error",
  },
  "Barcode.Illegible": {
    textId: "ELECTRONIC_ID_BARCODE_ILLEGIBLE",
    type: "error",
  },
  "RTCConnection.NotAvailable": {
    textId: "ELECTRONIC_ID_RTC_CONNECTION_NOT_AVAILABLE",
    type: "error",
  },
  "Bandwidth.TooLow": {
    textId: "ELECTRONIC_ID_BANDWITH_TOO_LOW",
    type: "error",
  },
  "Hologram.NotDetected": {
    textId: "ELECTRONIC_ID_HOLOGRAM_NOT_DETECTED",
    type: "error",
  },
  "Connection.Unstable": {
    textId: "ELECTRONIC_ID_CONNECTION_UNSTABLE",
    type: "error",
  },
  "Captcha.Invalid": {
    textId: "ELECTRONIC_ID_CAPTCHA_INVALID",
    type: "error",
  },
  "Authorization.Reused": {
    textId: "ELECTRONIC_ID_AUTHORIZATION_REUSED",
    type: "error",
  },
  "VideoID.BadRequest": {
    textId: "ELECTRONIC_ID_VIDEO_ID_BAD_REQUEST",
    type: "error",
  },
  "RTCConnection.Lost": {
    textId: "ELECTRONIC_ID_RTC_CONNECTION_LOST",
    type: "error",
  },
  "Barcode.NotDetected": {
    textId: "ELECTRONIC_ID_BARCODE_NOT_DETECTED",
    type: "error",
  },
  "FaceScanDiscontinuity.Detected": {
    textId: "ELECTRONIC_ID_FACE_SCAN_DISCONTINUITY",
    type: "error",
  },
  "User.Underage": {
    textId: "ELECTRONIC_ID_USER_UNDERAGE",
    type: "error",
  },
  "Camera.Unavailable": {
    textId: "ELECTRONIC_ID_CAMERA_UNAVAILABLE",
    type: "error",
  },
  "Document.Expired": {
    textId: "ELECTRONIC_ID_DOCUMENT_EXPIRED",
    type: "error",
  },
  "MicrophonePermission.Denied": {
    textId: "ELECTRONIC_ID_MICROPHONE_PERMISION_DENIED",
    type: "error",
  },
  "Document.WrongSide": {
    textId: "ELECTRONIC_ID_DOCUMENT_WRONG_SIDE",
    type: "error",
  },
  "SmileID.NotValidated": {
    textId: "ELECTRONIC_ID_SMILE_ID_NOT_VALIDATED",
    type: "error",
  },
  "IdType.Unauthorized": {
    textId: "ELECTRONIC_ID_TYPE_UNAUTHORIZED",
    type: "error",
  },
  "Connection.Lost": {
    textId: "ELECTRONIC_ID_CONNECTION_LOST",
    type: "error",
  },
  "Surface.NotReflective": {
    textId: "ELECTRONIC_ID_SURFACE_NOT_REFLECTIVE",
    type: "error",
  },
  "NoAgent.Available": {
    textId: "ELECTRONIC_ID_NO_AGENT_AVAILABLE",
    type: "error",
  },
  "Permission.Denied": {
    textId: "ELECTRONIC_ID_PERMISSION_DENIED",
    type: "error",
  },
  "Browser.NotSupported": {
    textId: "ELECTRONIC_ID_BROWSER_NOT_SUPPORTED",
    type: "error",
  },
  "Document.Illegible": {
    textId: "ELECTRONIC_ID_DOCUMENT_ILLEGIBLE",
    type: "error",
  },
  "User.Inactive": {
    textId: "ELECTRONIC_ID_USER_INACTIVE",
    type: "error",
  },
  "IdType.NotSupportedInWebBrowser": {
    textId: "ELECTRONIC_ID_TYPE_NOT_SUPPORTED_IN_WEB_BROWSER",
    type: "error",
  },
  "Recording.Error": {
    textId: "ELECTRONIC_ID_RECORDING_ERROR",
    type: "error",
  },
  "FaceSpoofing.Detected": {
    textId: "ELECTRONIC_ID_FACE_SPOOFING",
    type: "error",
  },
  "DocumentSidesMatch.NotPossible": {
    textId: "ELECTRONIC_ID_DOCUMENT_SIDES_MATCH_NOT_POSSIBLE",
    type: "error",
  },
  "RTCConnection.Error": {
    textId: "ELECTRONIC_ID_RTC_CONNECTION_ERROR",
    type: "error",
  },
  "CameraPermission.Denied": {
    textId: "ELECTRONIC_ID_CAMERA_PERMISSION_DENIED",
    type: "error",
  },
  "Liveness.NotDetected": {
    textId: "ELECTRONIC_ID_LIVENESS_NOT_DETECTED",
    type: "error",
  },
};
